import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Paper} from "@material-ui/core";
import {connect} from "react-redux";
import {loadLatestInstance} from "../../../actions";


/*
 * Suggested workflow
 * 1. If no instance selected, fire request to load instance 1 - display toast "Loading" and progress bar
 * 2. Once instance is loaded, fire request to load entries for first category in list
 * 3. Once category is loaded, display normally
 */

const styles = (theme) => ({
    root: {
        width: '100%'
    },
    table: {
        minWidth: 1020,
        width: '100%'
    },
    tableWrapper: {
        width: '100%',
        overflowX: 'auto'
    }
});


class EntriesPage extends Component {
    state = {
        order: 'asc',
        orderBy: null,
        page: 0,
        rowsPerPage: 10,
        selectedCategory: '',
        instance: {
            categories: []
        },
        columns: [],
        data: [],
        errorCode: null,
        errorMessage: null,
    };

    handleCategorySelect = (event) => {
        console.log("Selected category: " + event.target.value);
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({order, orderBy});
    };

    componentDidMount() {
        if (!this.state.instance) {
            this.props.loadLatestInstance();
        }
    }

    render() {
        const {classes} = this.props;

        return (
            <Paper className={classes.root}>
            </Paper>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        instance: state.root.instance,
        loginError: state.root.loadInstanceError
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadLatestInstance: () => dispatch(loadLatestInstance('Czech Open'))
    };
}


export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(EntriesPage));
